import { Form } from 'react-router-dom'
import React, { useState, useContext, useEffect } from 'react';
import Application from "../../../StateContext/Application";

const EditRoles = () => {
  const statecalls = useContext(Application);
  const { Usermenu, Roles, EditRoleActions } = statecalls;
  const [MenuList, SetMenuList] = useState([])
  const [Role, SetRoles] = useState([])
  const [AccessRole, SetAccessRole] = useState(false)
  const [menu, setmenu] = useState({})
  const [menuset, Menuaccess] = useState({})
  const [expandedMenuId, setExpandedMenuId] = useState(null);
  const [show, setshow] = useState(true)

  useEffect((e) => {
    Getdata()
  }, [])

  useEffect((e) => {
    uncheckAllCheckboxes()
    GetRolesActions()

  }, [AccessRole])

  async function objectpusher(event, menuname, access) {
    try {
      const updatedMenu = { ...menu };

      if (!event) {
        if (updatedMenu[menuname] && updatedMenu[menuname].includes(access)) {
          updatedMenu[menuname] = updatedMenu[menuname].filter(item => item !== access);
        }
      } else {
        // If event is true, add the access to the menu
        if (!Array.isArray(updatedMenu[menuname])) {
          updatedMenu[menuname] = [access];
        } else {
          updatedMenu[menuname] = [...updatedMenu[menuname], access];
        }
      }
      console.log(menu)
      setmenu(updatedMenu);
    } catch (error) {
      console.error(error);
    }
  }

  const menuSetter = (menukey, checked, ex) => {
    try {
      let main = false
      let id = ex.currentTarget.parentElement.parentElement
      if (!id.children[0].children[1].checked && !id.children[1].children[1].checked && !id.children[2].children[1].checked && !id.children[3].children[1].checked) {
        Menuaccess({ ...menuset, [menukey]: [AccessRole] });
      } else {
        let obj = { ...menuset };
        delete obj[menukey];
        Menuaccess(obj);
      }
    } catch (error) {
      console.error(error);
    }
  };



  async function Getdata() {
    try {
      const data = await Usermenu();
      let data1 = await Roles('View', null);
      SetRoles(data1);
      SetMenuList(data.result || []);
    } catch (error) {
      console.error(error);
    }
  }

  function uncheckAllCheckboxes() {
    try {
      // Get all checkboxes
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      // Uncheck each checkbox
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    } catch (error) {
      console.error('Error unchecking checkboxes:', error);
    }

  }
  async function GetRolesActions() {
    try {
      const data2 = await EditRoleActions('view', AccessRole);
      console.log(data2);
      const object = {};
      // document.querySelectorAll('input[type=checkbox]').forEach((x)=>{x.checked=false})
      data2 && data2.forEach(element => {
        const createRole = document.getElementById('CreateRole' + element.MenuId);
        const readRole = document.getElementById('ReadRole' + element.MenuId);
        const editRole = document.getElementById('EditRole' + element.MenuId);
        const deleteRole = document.getElementById('DeleteRole' + element.MenuId);

        if (createRole && readRole && editRole && deleteRole) {
          createRole.checked = element.create === "1" ? true : false;
          readRole.checked = element.view === "1" ? true : false;
          editRole.checked = element.edit === "1" ? true : false;
          deleteRole.checked = element.delete === "1" ? true : false;
        }

        // createRole.checked = element.create == "1"?true:false;
        //   readRole.checked = element.view =="1"?true:false;
        //   editRole.checked = element.edit == "1"?true:false;
        //   deleteRole.checked = element.delete == "1"?true:false;


        object[element.MenuId] = [
          element.create === "1" ? 'create' : null,
          element.view === "1" ? 'Read' : null,
          element.edit === "1" ? 'Edit' : null,
          element.delete === "1" ? 'Delete' : null,
        ];
      });

      setmenu(object);
    } catch (error) {
      console.error(error);
    }
  }

  const submit = async () => {
    try {
      let data2 = await EditRoleActions('update', AccessRole, menu, menuset);
      console.log(data2);
      alert("Edit Role Successfully")
    } catch (error) {
      console.error(error);
    }
  }
  const toggleMenu = (menuId) => {
    setExpandedMenuId(expandedMenuId === menuId ? null : menuId);
  };

  return (
    <div style={{ padding: '5rem', backgroundColor: '#f4f7fe',display: 'grid', gap: '1rem', }}>
      <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
        <div style={{ marginTop: 20, display: 'grid', width: '70.5vw', border: 'none', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", boxShadow: '0px 0px 5px' }}>
          <h5>Select Department</h5>
          <select onChange={(e) => { SetAccessRole(e.target.value) }} className="form-control" >
            <option value={false}>Please Select Role</option>
            {
              Role.map((e, index) => {
                return (
                  <option key={index} value={e.RoleID}>{e.Designation}</option>
                )
              })
            }

          </select>
        </div>
      </div>
      {show ?
        MenuList.map((e) => {
          if (e.Access_Role.includes(AccessRole) && e.Summenuid === 0) {
            return (
              <>
                <div className="accordion" id="accordionPanelsStayOpenExample" style={{ padding: 10, border: "3px solid lightgray", borderRadius: 7, backgroundColor: 'white' }}>
                  <div className="accordion-item" style={{ display: 'grid', gap: '0.5rem', border: 'none' }} >
                    <h2 className="accordion-header" id={`heading-${e.Menu_ID}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', backgroundColor: '#ff858591', borderRadius: '5px 5px 0px 0px', height: '2.5rem', border: '1px solid darkgray' }}>
                      <button
                        type="button"
                        onClick={() => toggleMenu(e.Menu_ID)}
                        style={{ display: 'flex', fontSize: '15px', color: '#052c65' }}
                      >
                        {e.Menu_Name} {expandedMenuId === e.Menu_ID ? "▼" : "▶"}
                      </button>

                    </h2>
                    <div style={{ backgroundColor: "#c8e5fc", display: "flex", justifyContent: "space-between", fontWeight: 600, marginTop: 10, padding: 10, border: '1px solid black' }}>
                      <b>{e.Menu_Name}</b>
                      <div >
                        <span className='mx-2'><b>Create</b><input type='checkbox' name={e.Menu_ID} id={'CreateRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'create'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                        <span className='mx-2'><b>Read</b><input type='checkbox' name={e.Menu_ID} id={'ReadRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'Read'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                        <span className='mx-2'><b>Edit</b><input type='checkbox' name={e.Menu_ID} id={'EditRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'Edit'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                        <span className='mx-2'><b>Delete</b><input type='checkbox' name={e.Menu_ID} id={'DeleteRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'Delete'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                      </div>
                    </div>
                    <div id={`collapse-${e.Menu_ID}`} className={`accordion-collapse collapse ${expandedMenuId === e.Menu_ID ? "show" : ""}`} aria-labelledby={`heading-${e.Menu_ID}`}>
                      <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                        <div className="accordion-body">
                          {MenuList.map((x) => {
                            if (e.Menu_ID === x.Summenuid) {
                              return (
                                <div style={{ display: 'flex', justifyContent: 'space-between', height: '2.5rem', alignItems: 'end', borderBottom: '1px solid black', padding: '0px 10px' }}>
                                  <label> {x.Menu_Name}</label>
                                  <div style={{ display: 'flex' }}>
                                    <span className='mx-2'><b>Create</b><input type='checkbox' name={x.Menu_ID} id={'CreateRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'create'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                                    <span className='mx-2'><b>Read</b><input type='checkbox' name={x.Menu_ID} id={'ReadRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'Read'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                                    <span className='mx-2'><b>Edit</b><input type='checkbox' name={x.Menu_ID} id={'EditRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'Edit'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                                    <span className='mx-2'><b>Delete</b><input type='checkbox' name={x.Menu_ID} id={'DeleteRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'Delete'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>

                                  </div>
                                </div>
                              )
                            }

                          })}


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
          }
          else if (e.Summenuid === 0 && !e.Access_Role.includes(AccessRole)) {
            return (
              <>
                 <div id={`collapse-${e.Menu_ID}`} className={`accordion-collapse collapse ${expandedMenuId === e.Menu_ID ? "show" : ""}`} aria-labelledby={`heading-${e.Menu_ID}`}>
                  <div className="accordion-item" style={{ display: 'grid', gap: '0.5rem', border: 'none' }} >
                    <h2 className="accordion-header" id={`heading-${e.Menu_ID}`} style={{ backgroundColor: '#ff858591', borderRadius: '5px', padding: '0rem 1rem', }}>
                      <button style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '15px', color: 'black', height: '2.5rem', width: '100%', }} type="button" onClick={() => toggleMenu(e.Menu_ID)}>
                        <div>
                          <b style={{ color: '#ed4848' }}>Do Not Have Access to {e.Menu_Name}</b>
                        </div>
                        <div>
                          <p style={{ marginBottom: '0px', marginTop: '1rem' }}>{e.Menu_Name}{expandedMenuId === e.Menu_ID ? ' ▼' : ' ▶'}</p>
                        </div>
                      </button>
                    </h2>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#c3dfe0', height: '2.5rem', padding: '0px 1rem' }}>
                      <div><b>{e.Menu_Name}</b></div>
                      <div style={{ display: 'flex' }}>
                        <span className='mx-2'><b>Create</b><input type='checkbox' name={e.Menu_ID} id={'CreateRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'create'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                        <span className='mx-2'><b>Read</b><input type='checkbox' name={e.Menu_ID} id={'ReadRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'Read'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                        <span className='mx-2'><b>Edit</b><input type='checkbox' name={e.Menu_ID} id={'EditRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'Edit'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                        <span className='mx-2'><b>Delete</b><input type='checkbox' name={e.Menu_ID} id={'DeleteRole' + e.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, e.Menu_ID, 'Delete'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                      </div>
                    </div>
                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                      <div className="accordion-body" style={{ padding: '0px' }}>
                        {MenuList.map((x, index) => {
                          if (e.Menu_ID === x.Summenuid) {
                            return (
                              <div key={index} style={{ display: 'flex', justifyContent: 'space-between', height: '2.5rem', alignItems: 'end', borderBottom: '1px solid black', padding: '0px 10px' }}>
                                <label> {x.Menu_Name}</label>
                                <div style={{ display: 'flex' }}>
                                  <span className='mx-2'><b>Create</b><input type='checkbox' name={x.Menu_ID} id={'CreateRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'create'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                                  <span className='mx-2'><b>Read</b><input type='checkbox' name={x.Menu_ID} id={'ReadRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'Read'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                                  <span className='mx-2'><b>Edit</b><input type='checkbox' name={x.Menu_ID} id={'EditRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'Edit'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>
                                  <span className='mx-2'><b>Delete</b><input type='checkbox' name={x.Menu_ID} id={'DeleteRole' + x.Menu_ID} onClick={(np) => { np.stopPropagation(); objectpusher(np.currentTarget.checked, x.Menu_ID, 'Delete'); menuSetter(np.currentTarget.name, np.currentTarget.checked, np) }} /></span>

                                </div>
                              </div>
                            )
                          }

                        })}


                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
          }
        }) : null
      }

      <div style={{ display: 'flex', gap: '10px' }}>
        <button onClick={(e) => { submit() }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "9rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>Change Access</button>
        <button type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}> Reset</button>
      </div>
    </div>

  )
}

export default EditRoles